import Broweser from '@/lib/browser';
import { debounce } from '@/lib/debounce';
import { addClass } from '@/lib/dom/addClass';
import { off } from '@/lib/dom/off';
import { on } from '@/lib/dom/on';
import { removeClass } from '@/lib/dom/removeClass';
import Dialog from '@/lib/easy-dialog';
import { lazyLoad } from '@/lib/lazyLoad';
import { loadCSS } from '@/lib/loadCSS';
import { loadJq } from '@/lib/loadJq';
import { loadJs } from '@/lib/loadJs';
import { ready } from '@/lib/ready';
import { aptip } from "@/lib/tooltip";
import '@/share/header'
// import '@/share/footer'


import "@/share/styles/common.less";
import "@/share/styles/components/container.less";
import "@/share/styles/components/layout.less";
import "@/share/styles/header.less";

// import "@/share/styles/footer.less";

Object.assign(globalThis, {
  loadCSS: loadCSS,
  loadJq: loadJq,
  loadJs: loadJs,
  ready: ready,
  lazyLoad: lazyLoad,
  Browser: Broweser,
  debounce: debounce,
  on: on,
  off: off,
  addClass,
  removeClass,
  dialog: {
    open: Dialog.open,
    close: Dialog.close
  },
  tooltip: aptip
});